"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var gettext_1 = require("./gettext");
function translate(gettext) {
    function validContext(context) {
        return typeof context === 'string' && context.length > 0;
    }
    return function execute(text, args, context) {
        if (args === void 0) { args = []; }
        var msgid = text.trim();
        if (validContext(context)) {
            msgid = context + "\u0004" + msgid;
        }
        var result = gettext.apply(void 0, __spread([msgid], args));
        if (result === msgid)
            return text;
        return result;
    };
}
exports.translate = translate;
exports.default = translate(gettext_1.gettext);
//# sourceMappingURL=translate.js.map